module.exports = __webpack_public_path__ + "img/hidden-image.91e8fdfe.png";